import React, { useEffect, useState } from "react";
import "./HomePage.css";
import EventCarousel from "./components/EventCarousel";
import HeroSection from "./components/HeroSection";
import TrendingSection from "./components/TrendingSection";

// Firestore imports removed
import { Link } from "react-router-dom";
import { ApiService } from "../../services/api_service";
import { getUserCoordinates, filterEventsByDistance } from "../../utils/geolocation";

const AllEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCity, setSelectedCity] = useState(localStorage.getItem("selectedCity") || "Bangalore");

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await ApiService.getAllEvents();
        // Handle response. data usually contains the list or map.
        // Assuming response is array or response.data is array/map
        let fetchedEvents = response.data || response;

        // If fetchedEvents is an object/map, convert to array
        if (fetchedEvents && !Array.isArray(fetchedEvents) && typeof fetchedEvents === 'object') {
          fetchedEvents = Object.values(fetchedEvents);
        }

        if (!Array.isArray(fetchedEvents)) {
          console.error("Unexpected events data format", fetchedEvents);
          fetchedEvents = [];
        }

        const eventsData = fetchedEvents.filter(event => {
          // Apply filters matching previous query
          const showInApp = event.showInApp === true || event.showInApp === null || event.showInApp === undefined;
          const notDummy = event.name !== 'Dummy Event';
          return showInApp && notDummy;
        });

        // Get user coordinates for distance-based filtering
        const userCoords = await getUserCoordinates(selectedCity);

        // 1. Featured Events - events where isFeatured == true
        const featuredEvents = eventsData.filter(event => event.isFeatured === true);

        // 2. Happening Near You - events within 50km radius
        const nearbyEvents = filterEventsByDistance(eventsData, userCoords, 50);

        // 3. Trending Events - no specific logic, just show any events
        const trendingEvents = eventsData.filter(event => !event.isFeatured);

        // 4. Popular Events - no specific logic, show any events
        const popularEvents = eventsData;

        // Store all categorized events
        setEvents({
          featured: featuredEvents,
          nearby: nearbyEvents,
          trending: trendingEvents,
          popular: popularEvents,
          all: eventsData
        });
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, [selectedCity]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#0a0a0a] via-[#111111] to-[#0a0a0a] flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#17BD3B]"></div>
          <p className="text-white/70 text-sm font-medium">Loading amazing events...</p>
        </div>
      </div>
    );
  }


  // Data for Sections - using categorized events
  const heroEvents = events.featured?.slice(0, 5) || [];
  const happeningNearMeEvents = events.nearby?.slice(0, 10) || [];
  const trendingFeatured = events.trending?.[0] || events.all?.[0];
  const trendingList = events.trending?.slice(1, 4) || [];
  const popularEvents = events.popular?.slice(0, 10) || [];

  return (
    <div className="min-h-screen bg-[#111111] text-white pb-20">

      {/* 1. Hero Section - Featured Events */}
      <div className="pt-[100px] sm:pt-[120px] px-4 sm:px-6 lg:px-[120px] mb-8">
        <HeroSection events={heroEvents} />
      </div>

      {/* 2. Popular Events - Any events */}
      <div className="px-4 sm:px-6 lg:px-[120px] mb-12">
        <EventCarousel
          events={popularEvents}
          title="Popular Events"
        />
      </div>

      {/* 3. Trending Section - Any events */}
      <TrendingSection
        featuredEvent={trendingFeatured}
        trendingEvents={trendingList}
        city={selectedCity}
      />

      {/* 4. Happening Near Me Carousel - Events within 50km */}
      <div className="px-4 sm:px-6 lg:px-[120px] mt-12 mb-12">
        <EventCarousel
          events={happeningNearMeEvents}
          title="Happening Near Me"
        />
      </div>



    </div>
  );
};

export default AllEvents;

